// sidebarConfig.tsx
import React from "react";
import { MenuSpec } from "./sidebarType";
import {  SidebarCareer, SidebarContent, SidebarInbox, SidebarMedia, SidebarOverview, SidebarWorkflow } from "../../../../asset-controller-mod/asset-serv/icons/iconExporter";

export const sidebarMenuConfig = (): MenuSpec[] => {
  return [
    {
      id: 1,
      label: "Overview",
      path: "/overview",
      menuIcon: <SidebarOverview />,
    },
    {
      id: 2,
      label: "Content",
      path: "/content",
      menuIcon: <SidebarContent />,
      children: [
        { id: 21, label: "Navigation", path: "/content/navigation" },
        { id: 22, label: "Product", path: "/content/product" },
        { id: 23, label: "Career", path: "/content/career" },
        { id: 24, label: "Contact", path: "/content/contact" },
        { id: 25, label: "Sale", path: "/content/sale" },
        { id: 26, label: "Business", path: "/content/business" },
        { id: 27, label: "Job Detail", path: "/content/job-detail" },
        { id: 28, label: "Company", path: "/content/company" },
      ],
    },
    {
      id: 3,
      label: "Media",
      path: "/media",
      menuIcon: <SidebarMedia />,
    },
    {
      id: 4,
      label: "Career",
      path: "/career",
      menuIcon: <SidebarCareer />,
      children: [
        { id: 401, label: "Hiring", path: "/career/hire" },
        { id: 402, label: "Submitted", path: "/career/submit" }
      ]

    },
    {
      id: 5,
      label: "Inbox",
      path: "/inbox",
      menuIcon: <SidebarInbox />,
    },
    {
      id: 6,
      label: "Workflow",
      path: "/workflow/manage",
      menuIcon: <SidebarWorkflow />,
    },
  ];
};